import React, { useEffect, useState } from 'react';

import type { MaintenanceListTableBriefBodyPricesData } from '@/components/sections/service/maintenance-list/table/brief/body/prices';
import { MaintenanceListTableBriefBodyPrices } from '@/components/sections/service/maintenance-list/table/brief/body/prices';
import { Box } from '@/components/shared/layout/box';
import { useWindowSize } from '@/components/shared/utility/hooks';

interface MaintenanceListTableBriefFooterPriceFixedProps
  extends MaintenanceListTableBriefBodyPricesData {
  elementIdToShow: string;
}

export const MaintenanceListTableBriefFooterPriceFixed = (
  props: MaintenanceListTableBriefFooterPriceFixedProps
) => {
  const windowSize = useWindowSize();
  const [showFixedPositionPrice, setShowFixedPositionPrice] =
    useState<boolean>(false);

  useEffect(() => {
    if (props.elementIdToShow.length === 0) return;

    const onScroll = () => {
      const el = document.getElementById(props.elementIdToShow);
      if (!el) return;

      const targetTop = el.getBoundingClientRect().top - window.innerHeight;
      if (targetTop > 0) {
        setShowFixedPositionPrice(true);
      } else {
        setShowFixedPositionPrice(false);
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [props.elementIdToShow]);
  return (
    windowSize.width &&
    windowSize.width < 768 && (
      <Box
        position="fixed"
        bottom="0"
        left="0"
        backgroundColor="white"
        zIndex="header"
        boxShadow="400"
        width="full"
        css={{
          transition: 'transform 0.3s var(--transition-easing)',
          willChange: 'transform',
          transform: showFixedPositionPrice
            ? 'translateY(0%)'
            : 'translateY(100%)',
        }}
        test={{ dataTest: 'maintenance_tableFixedPrice' }}
      >
        <MaintenanceListTableBriefBodyPrices
          selectedMaintenanceSchedule={props.selectedMaintenanceSchedule}
          priceData={props.priceData}
          isFooterFixed
        />
      </Box>
    )
  );
};
